import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered wider-modal" }
const _hoisted_2 = { class: "modal-content text-start" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "manageTimeWindowModalLabel"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "form-group mt-3" }
const _hoisted_9 = ["id", "value", "disabled"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "form-group mt-3" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "form-group mt-3"
}
const _hoisted_20 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_21 = { class: "p-3 d-flex justify-content-end align-items-center price-display" }
const _hoisted_22 = {
  class: "bi bi-info-circle",
  tabindex: "0",
  role: "button",
  "aria-label": "Info"
}
const _hoisted_23 = { class: "modal-footer text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UtilizationPricingSettings = _resolveComponent("UtilizationPricingSettings")!
  const _component_PriceUnitComponent = _resolveComponent("PriceUnitComponent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "manageTimeWindowModalLabel",
    tabindex: "-1",
    "aria-labelledby": "manageTimeWindowModalLabel",
    "aria-hidden": "true",
    ref: (el) => _ctx.$emit('set-modal-ref', el)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.modalTitle), 1),
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "timeWindowDescription" }, "Time Window Description (optional)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "timeWindowDescription",
                placeholder: "Enter description",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timeWindowDescription) = $event)),
                disabled: _ctx.operationType === 'delete'
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.timeWindowDescription]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[9] || (_cache[9] = _createElementVNode("label", null, "On the following days:", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "form-check form-check-inline",
                  key: day.name
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: day.name + 'Check',
                    value: day.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDays) = $event)),
                    disabled: _ctx.operationType === 'delete'
                  }, null, 8, _hoisted_9), [
                    [_vModelCheckbox, _ctx.selectedDays]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: day.name + 'Check'
                  }, _toDisplayString(day.name), 9, _hoisted_10)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { for: "timeRange" }, "Between:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    id: "startTime",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startTime) = $event)),
                    disabled: _ctx.operationType === 'delete'
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (time) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: time.value,
                        value: time.value
                      }, _toDisplayString(time.label), 9, _hoisted_15))
                    }), 128))
                  ], 8, _hoisted_14), [
                    [_vModelSelect, _ctx.startTime]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { for: "timeRange" }, "And:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    id: "endTime",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endTime) = $event)),
                    disabled: _ctx.operationType === 'delete'
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (time) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: time.value,
                        value: time.value
                      }, _toDisplayString(time.label), 9, _hoisted_18))
                    }), 128))
                  ], 8, _hoisted_17), [
                    [_vModelSelect, _ctx.endTime]
                  ])
                ])
              ])
            ]),
            (_ctx.currentStrategy.isAdjustByUtilization)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_UtilizationPricingSettings, {
                    ref: (el) => { _ctx.$emit('update:utilizationPriceSettingsRef', el as ComponentPublicInstance | null) },
                    initialData: _ctx.utilizationData,
                    isAllDay: true,
                    isAllWeek: false,
                    priceWindowId: _ctx.priceWindowId,
                    isDisabled: _ctx.operationType === 'delete'
                  }, null, 8, ["initialData", "priceWindowId", "isDisabled"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "Display at", -1)),
                    _createVNode(_component_PriceUnitComponent, {
                      ref: (el) => { _ctx.$emit('update:utilizationPriceSettingsRef', el as ComponentPublicInstance | null) },
                      value: _ctx.getUtilizationPrice(),
                      isPercent: _ctx.getUsePercent(),
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateUtilizationPrice($event))),
                      "onUpdate:isPercent": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateUsePercent($event)))
                    }, null, 8, ["value", "isPercent"]),
                    _withDirectives(_createElementVNode("i", _hoisted_22, null, 512), [
                      [_directive_tooltip, {
                    content:
                      'When applying this strategy:<br>If % is selected, a booking channel\'s pricing will be shown as this percentage of the regular rate.<br>If $ is selected, this amount will be shown.',
                    placement: 'top',
                    triggers: ['hover', 'focus'],
                    html: true,
                    popperClass: 'custom-tooltip',
                  }]
                    ])
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[14] || (_cache[14] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, " Cancel ", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
          }, _toDisplayString(_ctx.modalActionText), 1)
        ])
      ])
    ])
  ], 512))
}